import PropTypes from "prop-types"
import { useState } from "react"

const validation = (values) => {
  const errors = {}

  if (!values.first_name) {
    errors.first_name = "First name is required"
  }
  if (!values.last_name) {
    errors.last_name = "Last name is required"
  }
  if (!values.phone) {
    errors.phone = "Phone is required"
  }

  if (!values.street) {
    errors.street = "Address is required"
  }
  if (!values.locality) {
    errors.locality = "City is required"
  }

  if (!values.postal_code) {
    errors.postal_code = "Postal Code is required"
  }

  if (!values.country_name) {
    errors.country_name = "Country is required"
  }

  if (!values.email) {
    errors.email = "Email is required"
  }

  if (
    !values.email &&
    values.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
  ) {
    errors.email = "Email is invalid"
  }

  return errors
}

const RequestSampleForm = ({ originalSource, preview, model }) => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    street: "",
    locality: "",
    postal_code: "",
    country_name: "",
  })
  const [submitted, setSubmitted] = useState(false)
  const [errors, setErrors] = useState({})

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value })

  const onSubmit = (e) => {
    e.preventDefault()

    setSubmitted(true)

    const errors = validation(formData)

    if (Object.keys(errors).length === 0) {
      e.target.submit()
    } else {
      setErrors(errors)
    }
  }

  const onFocus = () => setSubmitted(false)

  return (
    <section>
      <form
        className="goBagRequestSample__form"
        action="/samples"
        method="post"
        onSubmit={onSubmit}
      >
        <div className="form-group">
          <input
            type="text"
            placeholder="First name *"
            value={formData.firstName}
            name="first_name"
            onChange={onChange}
            onFocus={onFocus}
          />

          {submitted && errors.first_name && (
            <small className="text-danger">{errors.first_name}</small>
          )}
        </div>

        <div className="form-group">
          <input
            type="text"
            className=""
            placeholder="Last name *"
            value={formData.lastName}
            name="last_name"
            onChange={onChange}
            onFocus={onFocus}
          />
          {submitted && errors.last_name && (
            <small className="text-danger">{errors.last_name}</small>
          )}
        </div>

        <div className="form-group">
          <input
            type="text"
            className=""
            placeholder="Email *"
            value={formData.email}
            name="email"
            onChange={onChange}
            onFocus={onFocus}
          />
          {submitted && errors.email && (
            <small className="text-danger">{errors.email}</small>
          )}
        </div>

        <div className="form-group">
          <input
            type="text"
            className=""
            placeholder="Phone *"
            value={formData.phone}
            name="phone"
            onChange={onChange}
            onFocus={onFocus}
          />
          {submitted && errors.phone && (
            <small className="text-danger">{errors.phone}</small>
          )}
        </div>

        <div className="form-group">
          <input
            type="text"
            className=""
            placeholder="Address *"
            value={formData.street}
            name="street"
            onChange={onChange}
            onFocus={onFocus}
          />
          {submitted && errors.street && (
            <small className="text-danger">{errors.street}</small>
          )}
        </div>

        <div className="form-group">
          <input
            type="text"
            className=""
            placeholder="City *"
            value={formData.locality}
            name="locality"
            onChange={onChange}
            onFocus={onFocus}
          />
          {submitted && errors.locality && (
            <small className="text-danger">{errors.locality}</small>
          )}
        </div>

        <div className="form-group">
          <input
            type="text"
            className=""
            placeholder="Postal Code *"
            value={formData.postal_code}
            name="postal_code"
            onChange={onChange}
            onFocus={onFocus}
          />
          {submitted && errors.postal_code && (
            <small className="text-danger">{errors.postal_code}</small>
          )}
        </div>

        <div className="form-group">
          <input
            type="text"
            className=""
            placeholder="Country *"
            value={formData.country_name}
            name="country_name"
            onChange={onChange}
            onFocus={onFocus}
          />
          {submitted && errors.country_name && (
            <small className="text-danger">{errors.country_name}</small>
          )}
        </div>

        <div className="text-right">
          <button type="submit" className="btn">
            Get Quote
          </button>
        </div>

        <input type="hidden" name="original_source" value={originalSource} />
        <input type="hidden" name="preview" value={preview} />
        <input type="hidden" name="model" value={model} />
      </form>
    </section>
  )
}

RequestSampleForm.propTypes = {
  originalSource: PropTypes.string.isRequired,
  preview: PropTypes.string.isRequired,
}

export default RequestSampleForm
